<template>
  <v-container fill-height fluid>
    <v-row justify="center">
      <v-col cols="12">
        <base-material-card :title="title">
          <v-form @submit.prevent="handleSubmit">
            <v-container class="py-0">
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    v-model="resource.chemicalManufacturer"
                    :disabled="isReadOnly"
                    :items="manufacturers"
                    autocomplete="off"
                    name="manufacturer"
                    label="Chemical Manufacturer"
                    item-text="name"
                    item-value="id"
                    hide-details
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="resource.name"
                    :disabled="isReadOnly"
                    autocomplete="off"
                    data-lpignore="true"
                    name="name"
                    label="Name"
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="resource.address"
                    :disabled="isReadOnly"
                    autocomplete="off"
                    data-lpignore="true"
                    name="address"
                    label="Address"
                  />
                </v-col>

                <v-col cols="3">
                  <v-text-field
                    v-model="resource.state"
                    :disabled="isReadOnly"
                    autocomplete="off"
                    data-lpignore="true"
                    name="state"
                    label="State"
                  />
                </v-col>

                <v-col cols="3">
                  <v-autocomplete
                    v-model="resource.timeZone"
                    :disabled="isReadOnly"
                    :items="timeZones"
                    name="timezone"
                    label="Time Zone"
                    hide-details
                  />
                </v-col>

                <v-col cols="4">
                  <v-switch
                    v-if="!isReadOnly"
                    v-model="resource.isMetric"
                    :label="`Units: ${resource.isMetric ? 'Metric' : 'Imperial'}`"
                    name="isMetric"
                  />
                  <v-text-field
                    v-else
                    :disabled="isReadOnly"
                    autocomplete="off"
                    name="isMetric"
                    label="Units"
                    :value="`${resource.isMetric ? 'Metric' : 'Imperial'}`"
                  />
                </v-col>

                <v-col cols="4">
                  <v-checkbox
                    v-for="ability in abilities"
                    :name="ability.model"
                    :key="ability.model"
                    :input-value="hasAbility(ability)"
                    @change="selectAbility(ability)"
                    :label="`${startCase(ability.model)}`"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <FormActions
                  :cancel="handleCancel"
                  :submit="handleSubmit"
                  :destroy="handleDestroy"
                  :canDestroy="canDestroy"
                  :canEdit="canEdit"
                  :canCreate="canCreate"
                  :isValid="isValid"
                  :submitting="submitting"
                />
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import _ from 'lodash';
import Formable from '@/mixins/formable';

const TIMEZONES = ['US/Eastern', 'US/Central', 'US/Mountain', 'US/Alaska', 'US/Pacific', 'UTC'];

export default {
  mixins: [Formable],
  props: {
    manufacturers: {
      type: Array,
      default: () => [],
    },
    abilities: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    valid() {
      return this.resource.chemicalManufacturer && this.resource.name;
    },
  },
  data() {
    return {
      resourceName: 'Site',
      timeZones: TIMEZONES,
    };
  },
  methods: {
    startCase: _.startCase,
    abilityIsActive(ability) {
      const found = this.hasAbility(ability);
      return found && !found.toDelete;
    },
    hasAbility(ability) {
      if (_.isEmpty(this.resource.siteAbilities)) {
        return false;
      }

      return !!this.resource.siteAbilities.find((siteAbility) => {
        return ability.id === _.get(siteAbility, 'ability.id');
      });
    },
    selectAbility(ability) {
      if (this.hasAbility(ability)) {
        this.removeAbility(ability);
      } else {
        this.addAbility(ability);
      }
    },
    removeAbility(ability) {
      const found = this.hasAbility(ability);
      if (found && found.id) {
        found.toDelete = true;
      } else {
        _.remove(this.resource.siteAbilities, { ability: { id: ability.id } });
      }
    },
    addAbility(ability) {
      const found = this.hasAbility(ability);
      if (found && found.id) {
        found.toDelete = false;
      } else {
        this.resource.siteAbilities.push({ ability: { id: ability.id, type: 'abilities' } });
      }
    },
  },
};
</script>
